import { PlanMeta } from './plans.types'
import { PLAN_CATEGORIES } from '../constants/globalStrings'

export const getPlanCategory = (plan: PlanMeta) => {
  if (plan.data_discount) return PLAN_CATEGORIES.DATA_DISCOUNT_SIM
  if (plan.plan_is_data_only) return PLAN_CATEGORIES.DATA_ONLY_SIM
  return PLAN_CATEGORIES.VOICE_SIM
}
